import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import "../Headers/HeaderStyles.css";
import LanguageIcon from '../../assets/images/Language.svg'
import { setLanguage } from '../../redux/comonSlice'; 

const SelectLanguage = () => {
    const currentLanguage = useSelector((state) => state.language.language);

    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const changeLanguage = (event) => {
        i18n.changeLanguage(event.target.value);
    };

    //   useEffect(() => {
    //     // const currentLanguage = getLocalStorage('currentLanguage') || 'en';
    //     i18n.changeLanguage(currentLanguage);
    //     dispatch(setLanguage(currentLanguage)); 
    //   })

    const handleChange = (event) => {
        const newLanguage = event.target.value;
        i18n.changeLanguage(newLanguage);
        dispatch(setLanguage(newLanguage)); // Update the language in the Redux store
    };

    return (
        <div>
            <span className="">

                {/* <select className="dropdown cly-btn" value={currentLanguage} onChange={handleChange} >
                    <option value="en">English</option>
                    <option value="zh">Mandarin</option>
                    <option value="tr">Turkish</option>
                    <option value="ba">Bahasa</option>
                    <option value="bg">Bangla</option>

                </select> */}
                <select className="lanuage-dt cly-btn" value={currentLanguage} onChange={handleChange} >
                                    <img src={LanguageIcon} className="img-fluid" alt='Select Language' />
                                        <option value="en">English</option>
                                        <option value="zh">Mandarin</option>
                                        <option value="tr">Turkish</option>
                                        <option value="ba">Bahasa</option>
                                        <option value="bg">Bangla</option>
                   
                                    </select>
                <i className="bi bi-chevron-down"></i> {/* Icon next to select */}

            </span>
        </div>
    );
    
}
export default SelectLanguage;
